import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["control", "name", "label", "error", "errorMode", "required", "dangerouslySetLabelInnerHtml", "checkboxSize", "sx"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isPropValid from '@emotion/is-prop-valid';
import { Box, Checkbox, checkboxClasses, css, FormControl, FormControlLabel, FormHelperText, styled, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FieldLabel = styled(Typography, {
  shouldForwardProp: isPropValid
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > * {\n    display: inline;\n    margin: 0;\n  }\n\n  ", "\n"])), function (_ref) {
  var required = _ref.required,
      theme = _ref.theme;
  return required && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      &:after {\n        content: '*';\n        margin-left: ", ";\n        color: ", ";\n      }\n    "])), theme.spacing(0.5), theme.palette.error.main);
});

var CheckBoxFormField = function CheckBoxFormField(_ref2) {
  var control = _ref2.control,
      name = _ref2.name,
      label = _ref2.label,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? control.getFieldState(name).error : _ref2$error,
      _ref2$errorMode = _ref2.errorMode,
      errorMode = _ref2$errorMode === void 0 ? 'label' : _ref2$errorMode,
      required = _ref2.required,
      _ref2$dangerouslySetL = _ref2.dangerouslySetLabelInnerHtml,
      dangerouslySetLabelInnerHtml = _ref2$dangerouslySetL === void 0 ? false : _ref2$dangerouslySetL,
      _ref2$checkboxSize = _ref2.checkboxSize,
      checkboxSize = _ref2$checkboxSize === void 0 ? 'medium' : _ref2$checkboxSize,
      sx = _ref2.sx,
      controllerProps = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsxs(FormControl, {
    required: required,
    error: !!error,
    sx: sx,
    "data-element": "FormControl",
    "data-component": "CheckBoxFormField",
    "data-source-file": "checkbox-form-field.tsx",
    children: [/*#__PURE__*/_jsx(FormControlLabel, {
      sx: {
        ml: -0.25,
        display: 'table'
      },
      label: /*#__PURE__*/_jsx(FieldLabel, _objectSpread({
        sx: {
          ml: 1
        },
        required: required
      }, dangerouslySetLabelInnerHtml ? {
        dangerouslySetInnerHTML: {
          __html: label
        }
      } : {
        children: label
      })),
      control: /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'table-cell',
          width: checkboxSize === 'small' ? 20 : 24
        },
        children: /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
          control: control,
          name: name
        }, controllerProps), {}, {
          rules: _objectSpread(_objectSpread({}, controllerProps.rules), {}, {
            required: required
          }),
          render: function render(_ref3) {
            var field = _ref3.field;
            return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
              sx: [{
                mb: 0.125,
                p: 0,
                alignSelf: 'start'
              }, errorMode === 'highlightCheckbox' && _defineProperty({
                color: function color(t) {
                  return error ? t.palette.error.main : t.palette.primary.main;
                }
              }, "&.".concat(checkboxClasses.checked), {
                color: function color(t) {
                  return t.palette.primary.main;
                }
              })],
              size: checkboxSize
            }, field), {}, {
              checked: field.value,
              inputProps: {
                'aria-label': 'controlled'
              }
            }));
          }
        }))
      }),
      "data-element": "FormControlLabel",
      "data-component": "CheckBoxFormField",
      "data-source-file": "checkbox-form-field.tsx"
    }), errorMode === 'label' && error && /*#__PURE__*/_jsx(FormHelperText, {
      sx: {
        mt: 0,
        ml: 0,
        color: function color(theme) {
          return theme.palette.error.main;
        }
      },
      children: /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t('This field is required.');
        }
      })
    })]
  });
};

export default CheckBoxFormField;